<template>
    <div class="news">
        <div class="container">
            <div class="row">
               <div class="col-md-12"><h3>Мэдээ мэдээлэл</h3></div>
            </div>
            <div class="row">
                <div class="col-md-3" :key="index" v-show="index <= 3" v-for="(shin, index) in news">
                    <div class="item">
                        <router-link :to="`/newsDetails/${shin.id}`">
                            <div class="view view-first">
                                <a href="">
                                    <img :src="shin.thumb" alt="">
                                </a>
                            </div>
                            <div class="repost-text">
                                <router-link  to="" class="title">
                                    Цаг үеийн мэдээ
                                </router-link>
                                <p>{{shin.title_mn}}</p>
                            </div>
                            <ul class="post-tags clearfix">
                                <li>{{shin.created_at | date}}</li>
                                <li class="right">Цааш унших <i class="fa fa-chevron-right"></i></li>
                            </ul>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="full_news">
                <div class="row" :key="index"  v-show="index >= 4" v-for="(shin, index) in news">
                    <div class="col-md-3">
                        <div class="news_image">
                            <router-link :to="`/newsDetails/${shin.id}`">
                                <img :src="shin.thumb" alt="">
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="news_text">
                            <h3 class="news_text_title">{{shin.title_mn}}</h3>
                            <div class="news_text_desc">
                                <p v-html="shin.des_mn"></p>
                            </div>
                            <div class="news_text_bottom">
                                <a class="turul">Шинэ мэдээ</a>
                                <router-link :to="`/newsDetails/${shin.id}`" class="right">Цааш унших <i class="fa fa-chevron-right"></i></router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="pagenation">
                        <Page  @on-change="changePage"
                               :current-page="current_page"
                               :page-size="9"
                               :total="total"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getNews } from "../../api/index"
    export default {

        components: {

        },
        data () {
            return {
                isLoading: false,
                news: [],
                current_page:1,
                last_page:1,
                total: 0,
            }
        },
        mounted () {
            this.calldata();
        },
        methods: {

            calldata(){
                this.$isLoading(true);
                getNews(this.current_page).then(response=>{
                    this.news = response.data.data;
                    this.current_page = response.data.current_page;
                    this.total = response.data.total;
                    console.log(this.news);
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
            changePage(page) {
                this.current_page = page;
                this.calldata();
            },
        },
    }
</script>
